import { useMutation, useQueryClient } from '@tanstack/react-query';

import { engagementResourcesService } from '../services';

import { engagementResourcesKeys } from './useEngagementResources';

export function useRemoveResourceLocations(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (locationIds: string[]) =>
      engagementResourcesService.removeLocations(id, locationIds),
    // onSettled (not onSuccess) so a partial-chunk failure still refreshes
    // the UI to whatever did persist. The service chunks at 100 per request
    // to stay under the BE cap.
    onSettled: () => {
      void qc.invalidateQueries({ queryKey: engagementResourcesKeys.detail(id) });
      void qc.invalidateQueries({ queryKey: engagementResourcesKeys.lists() });
    },
  });
}
